import {AddressTypeDataCreate} from "./address_type.type";
import axios from "axios";

async function createAddressTypeApi(data: AddressTypeDataCreate) {
    return axios({
        method: 'POST',
        url: '/api/v1/address-types',
        data: data
    });
}

async function getAddressTypesApi() {
    return axios({
        method: 'GET',
        url: '/api/v1/address-types'
    });
}
export {
    createAddressTypeApi,
    getAddressTypesApi,
}
